module.exports = __webpack_public_path__ + "img/zhuti.2f400f46.png";